import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useV2ProductRegulationSection } from './context'
import { RegulationEmptyPanel } from './RegulationEmptyPanel'
import { getRegulationEmptyStateKey } from './utils'

export function V2ProductRegulationSectionNotApplicableEmpty() {
  const { applicability, isLoading, actionsDisabled, openOverrideDialog } =
    useV2ProductRegulationSection()
  const { t } = useTranslation('common')

  if (isLoading || applicability?.status !== 'NOT_APPLICABLE') {
    return null
  }

  const emptyStateKey = getRegulationEmptyStateKey(applicability)

  return (
    <RegulationEmptyPanel
      title={t(
        `v2.pages.products.detail.regulationSection.empty.${emptyStateKey}.title`
      )}
      description={t(
        `v2.pages.products.detail.regulationSection.empty.${emptyStateKey}.description`
      )}
      action={
        <Button
          type='button'
          size='sm'
          variant='outline'
          disabled={actionsDisabled}
          onClick={openOverrideDialog}
        >
          {t('v2.applicability.override.button')}
        </Button>
      }
    />
  )
}
